import ApprovedArrow from "assets/icons/Arrows/Arrow1.svg";
import styled, { css } from "styled-components";

export const TableTitle = styled.div`
  margin-top: 15px;
  margin-bottom: 13px;
  font-weight: bold;
  font-size: 18.5px;
  line-height: 28px;
  color: #002e5c;
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #b5b5c3;
    padding-left: 11px;
  }
`;
export const Status = styled.div`
  padding-left: 9.08px;
  padding-top: 5.58px;
  padding-bottom: 5.58px;
  padding-right: 8.5px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  width: fit-content;
  ${(props) => {
    switch (props.type) {
      case "sent":
        return css`
          color: var(--Blue-100, #2555ef);
          background: var(--Blue-20, #eaeefc);
        `;
      case "opened":
        return css`
          color: var(--Indigo-100, #4b3ecf);
          background: var(--Indigo-20, #eae9fb);
        `;
      case "clicked":
        return css`
          color: var(--Purple-100, #7a3fd3);
          background: var(--Purple-20, #f1e9fb);
        `;
      case "completed":
        return css`
          color: var(--Green-100, #2e7d32);
          background: var(--Green-20, #e6f4ea);
        `;
      case "deleted":
        return css`
          color: var(--Red-100, #d32f2f);
          background: var(--Red-20, #fdecea);
        `;
      case "pending":
        return css`
          color: var(--Orange-100, #f57c00);
          background: var(--Orange-20, #fff3e0);
        `;
      default:
        return css`
          color: var(--Gray-100, #6b7280);
          background: var(--Gray-20, #f3f4f6);
        `;
    }
  }}
`;
export const CustomSelect = styled.div`
  width: 134.83px;
  position: relative;
`;
export const Select = styled.select`
  border-radius: 7px;
  width: 134.83px;
  height: 30px;
  gap: 20px;
  padding-left: 10px;
  font-weight: bold;
  font-size: 13px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  color: ${(props) =>
    props.typeStutus === "Approved"
      ? "#002E5C"
      : props.typeStutus === "Pending"
      ? "#FA3372"
      : "#FBA12C"};
  padding-left: ${(props) => props.typeStutus === "Approved" && "30px"};
`;
export const Img = styled.img`
  position: absolute;
  right: 10px;
  top: 40%;
`;

export const FilterWrapper = styled.div`
  width: 100%;
  height: 241px;
  padding-top: 25.17px;
  padding-bottom: 27px;
  padding-left: 31px;
  padding-right: 31px;
  margin-top: 15px;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  height: 44px;
  margin-top: 27px;
  margin-left: 30px;
`;
export const AccountWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Account = styled.button`
  font-size: 11px;
  line-height: 21px;
  text-transform: capitalize;
  color: #2455ef;
  font-weight: bold;
  background: transparent;
  border: none;
  text-align: left;
  padding: 0;
  &:hover {
    text-decoration-line: underline;
    cursor: pointer;
  }
`;

export const Label = styled.label`
  color: #002e5c;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
`;

export const DatePickerWrapper = styled.div`
  position: relative;

  & .react-datepicker-wrapper {
    width: 100%;
  }

  div {
    div.react-datepicker__input-container input {
      width: 100%;
      /* border: none; */
      background-color: rgb(246, 246, 246);
      border-radius: 5px;
      color: #3f4254;
      padding-inline: 10px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
